import FEATURES from '../access/features.json';

/**
 * Front twin of `backend/access/features.js`: same file, same answer. The server still decides
 * what it serves; this only hides what would be refused.
 *
 * @param {object|null} user
 * @param {string} key
 * @returns {boolean}
 */
export const can = (user, key) => {
  const rule = FEATURES[key];
  if (rule === undefined) throw new Error(`Unknown feature: ${key}`);
  if (!user) return false;
  return rule === 'all' || !!user[rule];
};

const ADMIN_RULES = new Set(['isadmin', 'issuperadmin']);

/**
 * Whether only administrators hold the feature today — the cue for the admin badge. Read from the
 * registry, so opening a feature to clients drops its badge everywhere at once.
 *
 * @param {string} key
 * @returns {boolean}
 */
export const isAdminOnly = (key) => {
  if (FEATURES[key] === undefined) throw new Error(`Unknown feature: ${key}`);
  return ADMIN_RULES.has(FEATURES[key]);
};
